import React, { useRef, useState } from 'react';
import { Button } from '@amzn/stencil-react-components/button';
import { Row, Spacer, View } from '@amzn/stencil-react-components/layout';
import { PopoverController, PopoverPosition } from '@amzn/stencil-react-components/popover';
import { Label, Text } from '@amzn/stencil-react-components/text';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { displayNotification } from '../../actions/notificationActions';
import { PARENTEX_CSV_TEMPLATE_HEADERS } from '../../constants/messages';

import { IconDownloadSmall } from '@amzn/stencil-react-icons';

const DownloadParentExTemplate = () => {
  const templateIcon = useRef();
  const dispatch = useDispatch();

  const [isInfoOpen, setIsInfoOpen] = useState(false);

  const toggle = () => setIsInfoOpen(!isInfoOpen);
  const close = () => setIsInfoOpen(false);

  const downloadTemplate = () => {
    const blob = new Blob([PARENTEX_CSV_TEMPLATE_HEADERS], {
      type: 'data:text/csv;charset=utf-8,',
    });
    const blobURL = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.download = 'ParentEx_Nudge_Template.csv';
    anchor.href = blobURL;
    anchor.dataset.downloadurl = ['text/csv', anchor.download, anchor.href].join(':');
    anchor.click();
    dispatch(
      displayNotification({
        message: 'ParentEx Template downloaded successfully',
        type: 'success',
        timeout: 1000,
      }),
    );
  };

  return (
    <View onMouseEnter={toggle} onMouseLeave={close}>
      <Button ref={templateIcon} hasIcon variant="tertiary">
        <Row gridGap="S200" alignItems="center">
          <IconDownloadSmall aria-hidden={true} />
          <FormattedMessage
            id="app.parentEx.parentEx.donwloadTemplate"
            defaultMessage="Download ParentEx Template.csv"
          />
        </Row>
      </Button>
      <PopoverController
        target={templateIcon}
        position={PopoverPosition.TopCenter}
        close={close}
        isOpen={isInfoOpen}
      >
        <View padding={15} display="flex" width={400} flexDirection="column" gridGap={10}>
          <Text fontWeight={'bold'}>
            <FormattedMessage
              id="app.templateCSV.message.mandatoryColumns"
              defaultMessage="Mandatory Colums"
            />
          </Text>
          <View display="flex" flexDirection="column">
            <Text>
              <FormattedMessage id="app.parentEx.column.runDate" defaultMessage="Run_Date" />
            </Text>
            <Label>
              <FormattedMessage id="app.parentEx.column.runDate.info" />
            </Label>
          </View>
          <Spacer height={15} />
          <View display="flex" flexDirection="column">
            <Text>
              <FormattedMessage id="app.parentEx.column.employee" defaultMessage="Employee" />
            </Text>
            <Label>
              <FormattedMessage id="app.parentEx.column.employee.info" />
            </Label>
          </View>
          <Spacer height={15} />
          <View display="flex" flexDirection="column">
            <Text>
              <FormattedMessage id="app.parentEx.column.manager" />
            </Text>
            <Label>
              <FormattedMessage id="app.parentEx.column.manager.info" />
            </Label>
          </View>
          <Spacer height={15} />
          <View display="flex" flexDirection="column">
            <Text>
              <FormattedMessage id="app.parentEx.column.template" />
            </Text>
            <Label>
              <FormattedMessage id="app.parentEx.column.template.info" />
            </Label>
          </View>
          <Spacer height={15} />
          <View display="flex" flexDirection="column">
            <Text>
              <FormattedMessage id="app.parentEx.column.employeeFirstName" />
            </Text>
            <Label>
              <FormattedMessage id="app.parentEx.column.employeeFirstName.info" />
            </Label>
          </View>
          <Spacer height={15} />
          <View display="flex" flexDirection="column">
            <Text>
              <FormattedMessage id="app.parentEx.column.managerFirstName" />
            </Text>
            <Label>
              <FormattedMessage id="app.parentEx.column.managerFirstName.info" />
            </Label>
          </View>
          <View display="flex" justifyContent="end">
            <Button variant="primary" onClick={downloadTemplate} data-testid="download-btn">
              <FormattedMessage id="app.templateCSV.donwload" defaultMessage="Close" />
            </Button>
            <Spacer width={15} />
            <Button variant="tertiary" onClick={close}>
              <FormattedMessage id="app.templateCSV.message.closeButton" defaultMessage="Close" />
            </Button>
          </View>
        </View>
      </PopoverController>
    </View>
  );
};

export default DownloadParentExTemplate;
